import React from 'react'

function WorkingProcessFive() {
    return (
        <div>
            {/* our working Process */}
            <div className="working-process-area rts-section-gap working-process-bg">
                <div className="container">
                    <div className="row mt--40">
                        <div className="title-area text-center working-process">
                            <span>Working Steps</span>
                            <h2 className="title">Our Basic Work Process</h2>
                        </div>
                    </div>
                    <div className="row g-5 mt--20 align-items-center">
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single wirking process */}
                            <div className="rts-working-process-1 text-center">
                                <div className="inner">
                                    <div className="icon">
                                        <img
                                            src="assets/images/working-step/icon/01.svg"
                                            alt="Working_process"
                                        />
                                    </div>
                                </div>
                                <div className="content">
                                    <h6 className="title">Make a Plan</h6>
                                    <p className="disc">
                                        Nostra proin fusce hendrerit <br /> viverra nisl torquent.
                                    </p>
                                </div>
                            </div>
                            {/* single wirking process End */}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single wirking process */}
                            <div className="rts-working-process-1 process-lg text-center">
                                <div className="inner two">
                                    <div className="icon">
                                        <img
                                            src="assets/images/working-step/icon/02.svg"
                                            alt="Working_process"
                                        />
                                    </div>
                                </div>
                                <div className="content">
                                    <h6 className="title">Cost Calculating</h6>
                                    <p className="disc">
                                        Nostra proin fusce hendrerit <br /> viverra nisl torquent.
                                    </p>
                                </div>
                            </div>
                            {/* single wirking process End */}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single wirking process */}
                            <div className="rts-working-process-1 text-center">
                                <div className="inner three">
                                    <div className="icon">
                                        <img
                                            src="assets/images/working-step/icon/03.svg"
                                            alt="Working_process"
                                        />
                                    </div>
                                </div>
                                <div className="content">
                                    <h6 className="title">Business Growth</h6>
                                    <p className="disc">
                                        Nostra proin fusce hendrerit <br /> viverra nisl torquent.
                                    </p>
                                </div>
                            </div>
                            {/* single wirking process End */}
                        </div>
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                            {/* single wirking process */}
                            <div className="rts-working-process-1 process-lg text-center">
                                <div className="inner four">
                                    <div className="icon">
                                        <img
                                            src="assets/images/working-step/icon/04.svg"
                                            alt="Working_process"
                                        />
                                    </div>
                                </div>
                                <div className="content">
                                    <h6 className="title">Success Mission</h6>
                                    <p className="disc">
                                        Nostra proin fusce hendrerit <br /> viverra nisl torquent.
                                    </p>
                                </div>
                            </div>
                            {/* single wirking process End */}
                        </div>
                    </div>
                </div>
            </div>
            {/* our working Process End */}
        </div>
    )
}

export default WorkingProcessFive